import Indicador from "..";
import PCorteEditFields from "./components/PCorteEditFields";
import { PCorteParamFields } from "./components/PCorteParamFields";
import pCorteReport from "./reports";
import pCorteReportSummary from "./reports/summary";

export default class PCorte extends Indicador { 
    static get fullName() {
        return "Profundidade do Corte de Soqueira";
    }

    static get abbrev() {
        return "P. Corte";
    }

    static get field() {
        return "pcorte";
    }

    static paramFields(tipoIndicadorField = "") {
        return <PCorteParamFields tipoIndicadorField={tipoIndicadorField} />;
    }

    static getEditFields(visita, isNew, TipoClass) {
        return <PCorteEditFields visita={visita} TipoClass={TipoClass} />;
    }

    async renderReport(visita) {
        return pCorteReport(this, visita);
    }

    async renderReportSummary(visita, tipoName) {
        return pCorteReportSummary(this, visita, tipoName);
    }

    static calcConformidade(apontamento, params) {
        const f = parseFloat;

        if (!apontamento.coletas || !params || apontamento.coletas.length === 0) {
            return 0;
        }

        let conformeCount = 0;
        const total = apontamento.coletas.length;

        for (const coleta of apontamento.coletas) {
            if (
                f(coleta.profundidadeCorte) >= f(params.intervaloMin) &&
                f(coleta.profundidadeCorte) <= f(params.intervaloMax)
            ) {
                coleta.conforme = "Sim";
                coleta.acima = 0
                coleta.abaixo = 0
                conformeCount++;
            } else {
                coleta.conforme = "Não";
                if (f(coleta.profundidadeCorte) > f(params.intervaloMax)) {
                    coleta.acima = 1
                    coleta.abaixo = 0
                } else {
                    coleta.acima = 0
                    coleta.abaixo = 1
                }
            }
        }

        return ((100 * conformeCount) / total).toFixed(2);
    }

    static getConformidadeStatus(conformidade, meta) {
        return this.calcConformidadeStatus(conformidade, meta, 86.9, 100, 107.14);
    }

    static getParams(cliente, tipo, TipoClass) {
        const params = cliente.getParams(PCorte, tipo, TipoClass);
        console.log("params ", params);

        if (params) {
            return {
                intervaloMin: params.intervaloMin,
                intervaloMax: params.intervaloMax,
                meta: params.meta,
            };
        }
    }

    static calcPontosAmostrados(apontamento, paramItems) {
        const result = [];

        for (const item of paramItems) {
            let count = 0;

            for (const coleta of apontamento.coletas) {
                if (this.calcPontoAmostradoColeta(item, coleta.profundidadeCorte)) {
                    count++;
                }
            }

            result.push({
                ...item,
                count: count,
            });
        }

        return result;
    }

    static getTableRelApontamentos(paramsCliente, IndicadorClass) {
        return [
            { title: "Data", width: "auto", getValue: (a) => a.dataRef.split("-").reverse().join("/") },
            { title: "Laudo", field: "laudoRef.sequencialIndex", width: 28 },
            { title: "Cod.", field: "laudoRef.fazenda.codFazenda", width: "auto" },
            { title: "Fazenda", field: "laudoRef.fazenda.nomeFazenda" },

            { title: "Talhão", field: "talhao.nome" },

            { title: "Frota", field: "trator.numeroFrotaTrator", width: "auto" },
            { title: "Frente", field: "frente", width: "auto" },
            { title: "Implemento", field: "implemento.nomeImplemento", width: "auto" },

            {
                title: "Profundidade",
                width: "auto",
                getValue: (a) => {
                    let sum = 0;
                    let arr = a.coletas.map((x) => {
                        if (x.profundidadeCorte) {
                            sum = sum + parseFloat(x.profundidadeCorte);
                            return x.profundidadeCorte;
                        } else {
                            return 0;
                        }
                    });

                    if (sum) {
                        return (sum / arr.length).toFixed(2);
                    } else {
                        return "0";
                    }
                },
            },

            {
                title: "Conf.(%)",
                field: "conformidade",
                width: 38,
                getColor: (a) => {
                    return IndicadorClass.getColorStatus(
                        IndicadorClass.getConformidadeStatus(a.conformidade, paramsCliente?.meta)
                    );
                },
            },
        ];
    }

    static getResultStr(apontamento) {
        let sum = 0;
        let media = 0;
        let arr = apontamento.coletas?.map((x) => {
            if (x.profundidadeCorte) {
                sum = sum + parseFloat(x.profundidadeCorte);
                return x.profundidadeCorte;
            } else {
                return 0;
            }
        });

        if (sum) {
            media = (sum / arr.length).toFixed(2);
        } else {
            media = "0";
        }

        return "Profundidade: " + media;
    }
}
